import { useRef as t } from "react";
function f(r) {
  const e = t(r);
  return e.current = r, () => e.current;
}
export {
  f as useRefPersistent
};
//# sourceMappingURL=index7.js.map
